import { render, staticRenderFns } from "./PageCustomerInformation.vue?vue&type=template&id=42314b77&scoped=true&"
import script from "./PageCustomerInformation.vue?vue&type=script&lang=js&"
export * from "./PageCustomerInformation.vue?vue&type=script&lang=js&"
import style0 from "./PageCustomerInformation.vue?vue&type=style&index=0&id=42314b77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42314b77",
  null
  
)

export default component.exports